"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var SignupModal_1 = require("./SignupModal");
var SignupPopup_1 = require("./components/SignupPopup");
var ModalWrapper_1 = require("../common/ModalWrapper");
var SignupContext_1 = require("./SignupContext");
var Signup = function () {
    var _a = (0, hooks_1.useContext)(SignupContext_1.SignupContext), modalOpen = _a.modalOpen, setModalOpen = _a.setModalOpen, miniPopupOpen = _a.miniPopupOpen;
    return ((0, preact_1.h)("div", { class: "signup-modal-section" },
        modalOpen && ((0, preact_1.h)(ModalWrapper_1.default, { children: (0, preact_1.h)(SignupModal_1.default, null), setOpen: setModalOpen !== null && setModalOpen !== void 0 ? setModalOpen : (function () { }), open: modalOpen })),
        !modalOpen && miniPopupOpen && window.localStorage.getItem('completedPopup') !== 'true' && ((0, preact_1.h)(SignupPopup_1.default, null))));
};
exports.default = Signup;
